import { WarningCircle } from "@phosphor-icons/react";
import styled from "@emotion/styled";
import { Button } from "@/components/primitives/Button";
import { Modal } from "../Modal";
import type { ConfirmDialogProps } from "./ConfirmDialog.types";

/* Exact compiled output of the pre-migration Tailwind utilities. */

const ConfirmDialogIconBubble = styled("div", {
  label: "AgenticConfirmDialog-iconBubble"
})({
  marginBottom: "1rem",
  display: "flex",
  width: "2.75rem",
  height: "2.75rem",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "var(--bfrs-radius-pill)",
  "--tw-bg-opacity": "1",
  backgroundColor: "hsl(var(--bfrs-color-danger-soft) / var(--tw-bg-opacity, 1))",
  "--tw-text-opacity": "1",
  color: "hsl(var(--bfrs-color-danger) / var(--tw-text-opacity, 1))"
});

export function ConfirmDialog({
  open,
  defaultOpen,
  onOpenChange,
  onClose,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  loading,
  destructive,
  disabledConfirm,
  icon,
  children,
  className
}: ConfirmDialogProps) {
  const handleCancel = () => {
    onCancel?.();
    onOpenChange?.(false);
    onClose?.();
  };

  return (
    <Modal
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      onClose={onClose}
      title={title}
      description={description}
      size="sm"
      preventClose={loading}
      className={className}
      footer={
        <>
          <Button variant="secondary" onClick={handleCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={destructive ? "destructive" : "primary"} loading={loading} disabled={disabledConfirm} onClick={() => void onConfirm?.()}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {(icon || destructive) && (
        <ConfirmDialogIconBubble>{icon ?? <WarningCircle size={24} weight="duotone" />}</ConfirmDialogIconBubble>
      )}
      {children}
    </Modal>
  );
}
